/**
 * Simple logger interface for version service
 * Provides abstraction over console methods for testability
 */
export interface ILogger {
  log(message: string, ...args: any[]): void;
  warn(message: string, ...args: any[]): void;
}

/**
 * Default console logger implementation
 */
export class ConsoleLogger implements ILogger {
  log(message: string, ...args: any[]): void {
    console.log(message, ...args);
  }

  warn(message: string, ...args: any[]): void {
    console.warn(message, ...args);
  }
}
